import { render } from "./HowItWorks.vue?vue&type=template&id=bce31490&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=bce31490&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce31490"]])

export default __exports__